// tslint:disable
export enum CampaignAttemptStatus {
    /**
     * @description UNKNOWN
     */
    UNKN = 10001,
    /**
     * @description SUCCESS
     */
    SUCC = 10002,
    /**
     * @description CALL FAILED
     */
    CFAIL = 10003,
    /**
     * @description INVALID ADDRESS
     */
    INADD = 10004,
    /**
     * @description NOT DELIVERED
     */
    NOTDEL = 10005,
    /**
     * @description Initiated
     */
    Initiated = 10006,
    /**
     * @description DocumentGenerated
     */
    DocumentGenerated = 10007,
    /**
     * @description FaxSubmitted
     */
    FaxSubmitted = 10008,
    /**
     * @description FaxSuccessful
     */
    FaxSuccessful = 10009,
    /**
     * @description FaxFailure
     */
    FaxFailure = 10010,
    /**
     * @description Shipped
     */
    Shipped = 10011,
    /**
     * @description PrintQueued
     */
    PrintQueued = 10012,
    /**
     * @description Void
     */
    Void = 10013,
    /**
     * @description Print Successful
     */
    Printed = 10014,
    /**
     * @description Document Print Failed
     */
    PrintFailed = 10015,
    /**
     * @description Inbound SMS Processed
     */
    InboundSMSProcessed = 20007,
    /**
     * @description Email Successful
     */
    EmailSuccessful = 30013,
    /**
     * @description Email Failure
     */
    EmailFailure = 30014,
    /**
     * @description SMS Successful
     */
    SMSSucessfull = 30015,
    /**
     * @description SMS Failure
     */
    SMSFailure = 30016,
    /**
     * @description Pending Vendor
     */
    PendingVendor = 30017,
    /**
     * @description Document Print Rejected
     */
    PrintRejected = 30018,
    /**
     * @description Document Failed To Generate
     */
    DocGenFailed = 30019,
    /**
     * @description File Failed To Copy
     */
    FileCopyFailed = 30020,
    /**
     * @description Attached Document Is Invalid
     */
    InvalidSecondaryDoc = 30021,
    /**
     * @description Failed to add document to document store
     */
    DocStoreFailed = 30022,
    /**
     * @description Document Needs Review
     */
    NeedsReview = 30023,
    /**
     * @description Document Under Review
     */
    UnderReview = 30024,
    /**
     * @description Document Review Rejected
     */
    DocumentRejected = 30025,
    /**
     * @description Document Approved
     */
    DocumentApproved = 30026,
    /**
     * @description Order - Acknowledged
     */
    OrderAcknowledged = 30027,
    /**
     * @description Order - Closed
     */
    OrderClosed = 30028,
    /**
     * @description Order - Damaged/Destroyed In Transit
     */
    OrderDamaged = 30029,
    /**
     * @description Order - Open
     */
    OrderOpen = 30030,
    /**
     * @description Order - Order Failed
     */
    OrderOrderFailed = 30031,
    /**
     * @description Order - Pending Vendor
     */
    OrderPendVendor = 30032,
    /**
     * @description Order - Returned
     */
    OrderReturned = 30033,
    /**
     * @description Order - Unverified Address
     */
    OrderUnverifAddr = 30034,
    /**
     * @description Order - Void
     */
    OrderVoid = 30035,
    /**
     * @description SMS message was delivered to the phone
     */
    SMSDelivered = 30036,
    /**
     * @description Missing Shipping Information
     */
    MissingShippingInfo = 30037,
    /**
     * @description Error Getting Data From Database
     */
    ErrorGettingData = 30038,
    /**
     * @description Failed
     */
    Failed = 30039,
    /**
     * @description Push of data to 3rd party failed
     */
    DataPushFailed = 30040,
}
(CampaignAttemptStatus as any)['INITIATED'] = 10006;
(CampaignAttemptStatus as any)['DOCUMENTGENERATED'] = 10007;
(CampaignAttemptStatus as any)['FAXSUBMITTED'] = 10008;
(CampaignAttemptStatus as any)['FAXSUCCESSFUL'] = 10009;
(CampaignAttemptStatus as any)['FAXFAILURE'] = 10010;
(CampaignAttemptStatus as any)['SHIPPED'] = 10011;
(CampaignAttemptStatus as any)['PRINTQUEUED'] = 10012;
(CampaignAttemptStatus as any)['VOID'] = 10013;
(CampaignAttemptStatus as any)['PRINTED'] = 10014;
(CampaignAttemptStatus as any)['PRINTFAILED'] = 10015;
(CampaignAttemptStatus as any)['INBOUNDSMSPROCESSED'] = 20007;
(CampaignAttemptStatus as any)['EMAILSUCCESSFUL'] = 30013;
(CampaignAttemptStatus as any)['EMAILFAILURE'] = 30014;
(CampaignAttemptStatus as any)['SMSSUCESSFULL'] = 30015;
(CampaignAttemptStatus as any)['SMSFAILURE'] = 30016;
(CampaignAttemptStatus as any)['PENDINGVENDOR'] = 30017;
(CampaignAttemptStatus as any)['PRINTREJECTED'] = 30018;
(CampaignAttemptStatus as any)['DOCGENFAILED'] = 30019;
(CampaignAttemptStatus as any)['FILECOPYFAILED'] = 30020;
(CampaignAttemptStatus as any)['INVALIDSECONDARYDOC'] = 30021;
(CampaignAttemptStatus as any)['DOCSTOREFAILED'] = 30022;
(CampaignAttemptStatus as any)['NEEDSREVIEW'] = 30023;
(CampaignAttemptStatus as any)['UNDERREVIEW'] = 30024;
(CampaignAttemptStatus as any)['DOCUMENTREJECTED'] = 30025;
(CampaignAttemptStatus as any)['DOCUMENTAPPROVED'] = 30026;
(CampaignAttemptStatus as any)['ORDERACKNOWLEDGED'] = 30027;
(CampaignAttemptStatus as any)['ORDERCLOSED'] = 30028;
(CampaignAttemptStatus as any)['ORDERDAMAGED'] = 30029;
(CampaignAttemptStatus as any)['ORDEROPEN'] = 30030;
(CampaignAttemptStatus as any)['ORDERORDERFAILED'] = 30031;
(CampaignAttemptStatus as any)['ORDERPENDVENDOR'] = 30032;
(CampaignAttemptStatus as any)['ORDERRETURNED'] = 30033;
(CampaignAttemptStatus as any)['ORDERUNVERIFADDR'] = 30034;
(CampaignAttemptStatus as any)['ORDERVOID'] = 30035;
(CampaignAttemptStatus as any)['SMSDELIVERED'] = 30036;
(CampaignAttemptStatus as any)['MISSINGSHIPPINGINFO'] = 30037;
(CampaignAttemptStatus as any)['ERRORGETTINGDATA'] = 30038;
(CampaignAttemptStatus as any)['FAILED'] = 30039;
(CampaignAttemptStatus as any)['DATAPUSHFAILED'] = 30040;
